import React, { FC } from 'react';
import { WidgetLazyLoader } from 'components/common/WidgetLazyLoader';
import { configuration } from 'config/constants';
import { useGetAppContextSubscription } from 'queries/AppContextSubscription/appContextSubscription.queries';

declare global {
    namespace React {
        namespace JSX {
            interface IntrinsicElements {
                'sgwt-account-center': {
                    id?: string;
                    'available-languages'?: string;
                    'user-dropdown-links'?: any;
                    authentication?: string;
                    environment?: string;
                    language?: string;
                    mode?: 'sg-markets';
                    debug?: string;
                    ref?: (elt: HTMLElement) => void;
                    'show-sign-in-button'?: boolean;
                    'navigate-as'?: boolean;
                    'navigate-as-list'?: string;
                    'navigate-as-user'?: string;
                };
            }
        }
    }
}

export const SgwtAccountCenter: FC = () => {
    const { data } = useGetAppContextSubscription();
    const environment = data?.environment;

    return (
        <WidgetLazyLoader script={`${configuration.widgetCdnBaseUrl}/widgets/sgwt-account-center/v4/sgwt-account-center.js`}>
            <sgwt-account-center
                id="sgwtAccountCenter"
                language="en"
                available-languages="en"
                authentication="sg-connect-v2"
                mode="sg-markets"
                // producer-code="sgm_release"
                environment={environment?.toUpperCase() === 'PRODUCTION' ? undefined : environment || undefined}
            />
        </WidgetLazyLoader>
    );
};
